export default __webpack_public_path__ + "static/media/banner-3.f63d175b.png";